module.exports = __webpack_public_path__ + "static/scale-model-of-boulder-colorado-0de0e015658d1acb17c5811be1ad4be6.png";